"use strict";
var isEn = true
function ownKeys(t, e) {
  var i, s = Object.keys(t);
  return Object.getOwnPropertySymbols && (i = Object.getOwnPropertySymbols(t),
  e && (i = i.filter(function(e) {
    return Object.getOwnPropertyDescriptor(t, e).enumerable
  })),
  s.push.apply(s, i)),
  s
}
function _objectSpread(t) {
  for (var e = 1; e < arguments.length; e++) {
    var i = null != arguments[e] ? arguments[e] : {};
    e % 2 ? ownKeys(Object(i), !0).forEach(function(e) {
      _defineProperty(t, e, i[e])
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(i)) : ownKeys(Object(i)).forEach(function(e) {
      Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(i, e))
    })
  }
  return t
}
function _defineProperty(e, t, i) {
  return t in e ? Object.defineProperty(e, t, {
    value: i,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = i,
  e
}
function _classCallCheck(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function")
}
function _defineProperties(e, t) {
  for (var i = 0; i < t.length; i++) {
    var s = t[i];
    s.enumerable = s.enumerable || !1,
    s.configurable = !0,
    "value"in s && (s.writable = !0),
    Object.defineProperty(e, s.key, s)
  }
}
function _createClass(e, t, i) {
  return t && _defineProperties(e.prototype, t),
  i && _defineProperties(e, i),
  e
}
function screenMaxThan768() {
  var s = function() {
    function i(e) {
      var t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {};
      return _classCallCheck(this, i),
      this.el = e,
      this.offset = void 0 === t.offset ? 60 : t.offset,
      this.fixedWrap = $(e).find(t.fixedWrap),
      this.status = "up",
      this.isScrollUp = !1,
      this.isScrollDown = !1,
      this.options = t,
      this.id = t.id,
      this.progress = 0,
      this.init(),
      this
    }
    return _createClass(i, [{
      key: "init",
      value: function() {
        var e, t = this.el;
        $(t).length && (e = this.options,
        this.offset = e.getOffset ? e.getOffset() : void 0 === e.offset ? 60 : e.offset,
        this.elHeight = $(t).outerHeight(),
        this.fixedWrapHeight = this.fixedWrap.outerHeight(),
        this.startTop = $(t).offset().top - this.offset,
        this.endTop = $(t).offset().top + $(t).outerHeight() - $(window).outerHeight(),
        this.leaveViewTopValue = $(t).offset().top - $(window).outerHeight(),
        this.leaveViewBottomValue = $(t).offset().top + $(t).outerHeight() - this.offset,
        this.fixedClass = e.getFixedClass ? e.getFixedClass() : e.fixedClass,
        this.absClass = e.getAbsClass ? e.getAbsClass() : e.absClass,
        this.needHandleScroll = !e.judgeNeedHandleScroll || e.judgeNeedHandleScroll(),
        e.setCustomInfo && e.setCustomInfo(this),
        console.log("DomStickyWatch", this))
      }
    }, {
      key: "reset",
      value: function() {
        this.init(),
        this.options.reset && this.options.reset(this)
      }
    }, {
      key: "scrollHandle",
      value: function(e) {
        var t, i, s, a, o, n;
        this.needHandleScroll && (t = this.options,
        i = {
          scrollTop: e,
          el: this.el,
          options: t,
          vm: this
        },
        s = this.fixedClass || "scroll-fixed",
        a = this.absClass || "scroll-abs-bot",
        o = this.allFixedClass,
        e < this.startTop ? (this.progress = 0,
        this.fixedWrap.removeClass(o || s).removeClass(a),
        t.scrollUpHandle && t.scrollUpHandle(i)) : e >= this.startTop && e < this.endTop ? (n = (e - this.startTop) / (this.elHeight - this.fixedWrapHeight),
        this.progress = n,
        this.fixedWrap.addClass(s).removeClass(a),
        t.scrollInHandle && t.scrollInHandle(_objectSpread(_objectSpread({}, i), {}, {
          progress: n
        }))) : (this.progress = 1,
        this.fixedWrap.removeClass(o || s).addClass(a),
        t.scrollOutHandle && t.scrollOutHandle(i)),
        e > this.leaveViewBottomValue || e < this.leaveViewTopValue ? t.domNoInViewHandle && t.domNoInViewHandle(i) : t.domInViewHandle && t.domInViewHandle(i),
        t && t.progressHandle(this))
      }
    }]),
    i
  }()
    , e = function() {
    function t() {
      var i, s, a, e = this;
      _classCallCheck(this, t),
      this.id = 1,
      this.queue = [],
      this.idMap = {},
      this.resetHandle = (i = function() {
        e.queue.forEach(function(e) {
          e.reset && e.reset()
        })
      }
      ,
      s = 500,
      a = null,
      function() {
        var e = this
          , t = arguments;
        clearTimeout(a),
        a = setTimeout(function() {
          i.apply(e, t)
        }, s)
      }
      )
      // setTimeout(function() {
      //   e.excuteWatchHandle(),
      //   e.resetHandle(),
      //   $(window).scroll(function() {
      //     e.excuteWatchHandle()
      //   }),
      //   $(window).resize(function() {
      //     e.resetHandle(),
      //     e.excuteWatchHandle()
      //   })
      // }, 200)
    }
    return _createClass(t, [{
      key: "getId",
      value: function() {
        var e = Math.random() + String(this.id);
        return this.id++,
        e
      }
    }, {
      key: "unbind",
      value: function(t) {
        t.options && t.options.id && (this.queue = this.queue.filter(function(e) {
          return e.id !== t.options.id
        }))
      }
    }, {
      key: "add",
      value: function(e) {
        var t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {}
          , i = this.getId()
          , t = "sticky" === t.mode ? new s(e,_objectSpread(_objectSpread({}, t), {}, {
          id: i
        })) : new a(e,_objectSpread(_objectSpread({}, t), {}, {
          id: i,
          unbindHandle: this.unbind.bind(this)
        }));
        this.idMap[i] = t,
        this.queue.push(t)
      }
    }, {
      key: "excuteWatchHandle",
      value: function() {
        // 0 !== this.queue.length && this.queue.forEach(function(e) {
        //   e && e.scrollHandle && e.scrollHandle($(window).scrollTop())
        // })
      }
    }]),
    t
  }()
    , a = function() {
    function i(e) {
      var t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {};
      return _classCallCheck(this, i),
      this.el = e,
      this.offset = t.offset || 0,
      this.init(),
      this.status = "up",
      this.isScrollUp = !1,
      this.isScrollDown = !1,
      this.options = t,
      this.id = t.id,
      this
    }
    return _createClass(i, [{
      key: "init",
      value: function() {
        var e = this.el;
        this.elHeight = $(e).outerHeight(),
        this.startTop = $(e).offset().top - $(window).outerHeight() + this.offset,
        this.endTop = $(e).offset().top + $(e).outerHeight(),
        this.leaveViewTopValue = $(e).offset().top - $(window).outerHeight(),
        this.leaveViewBottomValue = $(e).offset().top + $(e).outerHeight() - this.offset
      }
    }, {
      key: "reset",
      value: function() {
        this.init()
      }
    }, {
      key: "scrollHandle",
      value: function(e) {
        var t, i = this.options, s = {
          scrollTop: e,
          el: this.el,
          options: i
        };
        e < this.startTop ? (i.scrollOutHandle && i.scrollOutHandle(s),
        i.scrollOutUpHandle && i.scrollOutUpHandle(s)) : e >= this.startTop && e < this.endTop ? (t = (e - this.startTop) / this.elHeight,
        this.progress = Math.min(1, t),
        i.scrollInHandle && i.scrollInHandle(_objectSpread(_objectSpread({}, s), {}, {
          progress: this.progress
        })),
        i.once && i.unbindHandle && i.unbindHandle && i.unbindHandle(_objectSpread(_objectSpread({}, s), {}, {
          progress: this.progress
        }))) : (this.progress = 1,
        i.scrollOutHandle && i.scrollOutHandle(_objectSpread(_objectSpread({}, s), {}, {
          progress: this.progress
        })),
        i.scrollOutBottomHandle && i.scrollOutBottomHandle(_objectSpread(_objectSpread({}, s), {}, {
          progress: this.progress
        }))),
        e > this.leaveViewBottomValue || e < this.leaveViewTopValue ? i.domNoInViewHandle && i.domNoInViewHandle(s) : i.domInViewHandle && i.domInViewHandle(s)
      }
    }]),
    i
  }()
    , t = new e;
  t.add(document.getElementById("farming-time-wrap"), {
    mode: "sticky",
    fixedWrap: "#farming-time-fixed-item",
    offset: 52,
    progressHandle: function(e) {
      e.progress && (e.progress < .4 ? ($(e.el).find(".image1").fadeIn(500),
      $(e.el).find(".image2").fadeOut(500)) : ($(e.el).find(".image1").fadeOut(500),
      $(e.el).find(".image2").fadeIn(500)))
    }
  });
  new Swiper(".part-6-swiper-container",{
    effect: "slide",
    height: 500,
    centeredSlides: !0,
    speed: 500,
    autoplay: 5000,
    prevButton: "#swiper-left-btn",
    nextButton: "#swiper-right-btn",
    noSwipingClass: "swiper-button-disabled",
    onInit: function(e) {
      $("#swiper-bottom-wrap-left").html(' <div class="swiper-bottom-wrap-left-title">测绘器打点</div>\n          <div class="swiper-bottom-wrap-left-description">可选配<span>极飞 <span class="en en-bold">XRTK6</span> 手持测绘器</span>，在需要标记的地块边界上方打点，标记完所有边界点后，<br/>点击 <span class="en">App</span> 上的&nbsp;“&nbsp;自动闭合&nbsp;”，<span class="en">App</span> 将自动生成作业路径。</div>\n          ')
    },
    onSlideChangeEnd: function(e) {
      var t = e.activeIndex;
      switch (console.log(e, t),
      t) {
      case 0:
        $("#swiper-bottom-wrap-left").html(' <div class="swiper-bottom-wrap-left-title">测绘器打点</div>\n          <div class="swiper-bottom-wrap-left-description">可选配<span>极飞 <span class="en en-bold">XRTK6</span> 手持测绘器</span>，在需要标记的地块边界上方打点，标记完所有边界点后，<br/>点击 <span class="en">App</span> 上的“自动闭合”，<span class="en">App</span> 将自动生成作业路径。</div>\n          ');
        break;
      case 1:
        $("#swiper-bottom-wrap-left").html(' <div class="swiper-bottom-wrap-left-title">高清图打点</div>\n          <div class="swiper-bottom-wrap-left-description">在 <span class="en">App</span> 上导入由<span>睿图/遥感无人飞机</span>航测的高清图，即可进行打点，生成作业路径。</div>\n          ');
        break;
      case 2:
        $("#swiper-bottom-wrap-left").html(' <div class="swiper-bottom-wrap-left-title">农机打点</div>\n          <div class="swiper-bottom-wrap-left-description">驾驶<span>农机</span>至地块边界上方，行驶标记 <span class="en">AB</span> 直线或录制曲线，设置参数后， <span class="en">APP</span> 将自动生成<br/>多条路径。</div>')
      }
    }
  }),
  new Swiper(".part-6-swiper-container-en",{
    effect: "slide",
    height: 500,
    centeredSlides: !0,
    speed: 500,
    autoplay: 5000,
    prevButton: "#swiper-left-btn",
    nextButton: "#swiper-right-btn",
    noSwipingClass: "swiper-button-disabled",
    onInit: function(e) {
      console.log("part6Swiper-init"),
      $("#swiper-bottom-wrap-left").html(' <div class="swiper-bottom-wrap-left-title ft-ddin-bold">Waypoint marking with control stick </div>\n          <div class="swiper-bottom-wrap-left-description">Use the XAG XRTK6 Pro Handheld Control Stick to mark points along the field boundaries. Click <br />on "Auto-Close" in the App to generate routes automatically.\t</div>\n          ')
    },
    onSlideChangeEnd: function(e) {
      var t = e.activeIndex;
      switch (console.log(e, t),
      t) {
      case 0:
        $("#swiper-bottom-wrap-left").html(' <div class="swiper-bottom-wrap-left-title ft-ddin-bold">Waypoint marking with control stick </div>\n          <div class="swiper-bottom-wrap-left-description">Use the XAG XRTK6 Pro Handheld Control Stick to mark points along the field boundaries. Click <br />on "Auto-Close" in the App to generate routes automatically.\t</div>\n          ');
        break;
      case 1:
        $("#swiper-bottom-wrap-left").html(' <div class="swiper-bottom-wrap-left-title ft-ddin-bold">Waypoint marking with HD field maps\t</div>\n          <div class="swiper-bottom-wrap-left-description">Map the fields with XAG Remote Sensing Drone or RealTerra. Import HD field maps into the App, <br />mark the points and generate routes.</div>\n          ');
        break;
      case 2:
        $("#swiper-bottom-wrap-left").html(' <div class="swiper-bottom-wrap-left-title ft-ddin-bold">Waypoint marking with farm machinery\t</div>\n          <div class="swiper-bottom-wrap-left-description">Drive your vehicle along the field edge, and mark the AB straight line or record a curve. The App <br />will automatically generate multiple routes after parameter setting.\t</div>')
      }
    }
  });
  var i = new Swiper(".part-3-swiper-container",{
    effect: "slide",
    centeredSlides: !0,
    prevButton: "#part-3-swiper-btn-left",
    nextButton: "#part-3-swiper-btn-right",
    noSwipingClass: "swiper-button-disabled",
    onInit: function(e) {
      e = e.activeIndex;
      $(".dot").eq(e).addClass("dot-active"),
      $(".dot").eq(e).siblings().removeClass("dot-active")
    },
    onSlideChangeEnd: function(e) {
      e = e.activeIndex;
      $(".dot").eq(e).addClass("dot-active"),
      $(".dot").eq(e).siblings().removeClass("dot-active")
    }
  });
  isEn && (new Swiper(".part-3-swiper-container-en",{
    effect: "slide",
    centeredSlides: !0,
    prevButton: "#part-3-swiper-btn-left",
    nextButton: "#part-3-swiper-btn-right",
    noSwipingClass: "swiper-button-disabled",
    onInit: function(e) {
      e = e.activeIndex;
      $(".dot").eq(e).addClass("dot-active"),
      $(".dot").eq(e).siblings().removeClass("dot-active")
    },
    onSlideChangeEnd: function(e) {
      e = e.activeIndex;
      $(".dot").eq(e).addClass("dot-active"),
      $(".dot").eq(e).siblings().removeClass("dot-active")
    }
  }),
  t.add($(".part-route-plan").get(0), {
    offset: 0,
    once: !0,
    scrollInHandle: function(e) {
      $(".part-route-plan .lazy").each(function(e, t) {
        $(t).css("background-image", "url(".concat($(t).attr("data-pc"), ")"))
      })
    }
  })),
  $("#car-bg").on("appear", function() {
    $(".dot").css("visibility", "visible")
  }),
  $(".dot").each(function(e) {
    $(this).on("click", function() {
      console.log("dot-index", e, $(this).data("id")),
      $(".dot").eq(e).addClass("dot-active"),
      i.slideTo($(this).data("id")),
      $(".dot").eq(e).siblings().removeClass("dot-active")
    })
  })
  // $(window).scroll(function() {
  //   $("#header-video").is(":visible") && ($(window).scrollTop() > $("#header").height() ? $("#header-video")[0].pause() : $("#header-video")[0].play())
  // });
  var n;
  new Swiper(".gallery-swiper-wrap",{
    grabCursor: !0,
    centeredSlides: !0,
    slidesPerView: "auto",
    spaceBetween: 24,
    preloadImages: !0,
    prevButton: ".swiper-nav-prev",
    nextButton: ".swiper-nav-next",
    noSwipingClass: "swiper-nav-disabled",
    pagination: ".gallery-swiper-pagination",
    paginationClickable :true,
    paginationBulletRender: function(e, t) {
      return '<span class="' + t + '"></span>'
    }
  });
  isEn && (n = "0",
  0 !== $(".part-optional-accessories").length && $(".part-optional-accessories .left >div").click(function() {
    var e, t = $(this).attr("data-index");
    n !== t && ($(".part-optional-accessories .left >div").addClass("block-close"),
    $(this).removeClass("block-close"),
    (e = $(".part-optional-accessories .right >div")).eq(Number(n)).fadeOut(),
    e.eq(Number(t)).fadeIn(),
    n = t)
  }))
}

function screenMixThan768() {
  new Swiper(".part-03-swiper-container",{
    effect: "slide",
    centeredSlides: !0,
    prevButton: "#part-03-swiper-btn-left",
    nextButton: "#part-03-swiper-btn-right",
  });
  isEn && ($(".part-optional-accessories .right .lazy").attr("data-use-effect", ""),
  new Swiper(".part-3-swiper-container-en",{
    effect: "slide",
    centeredSlides: !0,
    prevButton: "#part-3-swiper-btn-left",
    nextButton: "#part-3-swiper-btn-right",
    noSwipingClass: "part-3-swiper-btn-disabled",
    onSlideChangeEnd: function(e) {
      console.log("111", 111);
      e = e.activeIndex,
      e = $(".part-3-swiper-wrap .part-3-img").eq(e);
      e.attr("style") || e.attr("style", "background-image: url(".concat(e.attr("data-mobile"), ")"))
    }
  }),
  $(".part-productivity .photo-list").removeClass("ft-ddin-bold"))
}
function init() {
  $(".lazy").filter(function() {
    return !($(this).hasClass("not-lazy") || $(this).hasClass("part-3-lazy") || $(this).hasClass("part-6-lazy") || $(this).hasClass("part-2-lazy") || $(this).hasClass("part-9-lazy") || $(this).hasClass("part-4-lazy") || $(this).hasClass("part-03-lazy"))
  }).lazyload(),
  768 < $(window).width() ? (screenMaxThan768(),
  $(".not-lazy").lazyload({
    skip_invisible: !1,
    container: $(".part-7"),
    customerUpdateJudge: function(e) {
      e.trigger("appear")
    }
  }),
  $(".part-2-lazy").lazyload({
    skip_invisible: !1,
    container: $(".part-2"),
    customerUpdateJudge: function(e) {
      e.trigger("appear")
    }
  }),
  $(".part-3-lazy").lazyload({
    skip_invisible: !1,
    container: $(".part-3"),
    customerUpdateJudge: function(e) {
      e.trigger("appear")
    }
  }),
  $(".part-6-lazy").lazyload({
    skip_invisible: !1,
    container: $(".part-6"),
    customerUpdateJudge: function(e) {
      e.trigger("appear")
    }
  }),
  $(".part-9-lazy").lazyload({
    skip_invisible: !1,
    container: $(".part-9"),
    customerUpdateJudge: function(e) {
      e.trigger("appear")
    }
  }),
  $(".part-4-lazy").lazyload({
    skip_invisible: !1,
    container: $(".part-4"),
    customerUpdateJudge: function(e) {
      e.trigger("appear")
    }
  })) : (screenMixThan768(),
  $(".not-lazy").lazyload({
    skip_invisible: !1,
    container: $(".part-03"),
    customerUpdateJudge: function(e) {
      e.trigger("appear")
    }
  }))

  
  var video = document.querySelector("#iframeId")
  $("#view-video").click(function() {
    $(".cover-screen").width($(window).width())
    $(".cover-screen").height($(window).height())
    $(".cover-screen").show()
    video.play()
  })
  
  $(".close-video").click(function() {
    video.currentTime = 0; 
    video.pause()
    $(".cover-screen").hide()
  })
}
$(document).ready(init),
$(window).resize(init);